import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Zap } from 'lucide-react';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'How It Works',
    path: '/#how-it-works'
  }, {
    name: 'Characters',
    path: '/characters'
  }, {
    name: 'Pricing',
    path: '/pricing'
  }];
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-charcoal/95 backdrop-blur-md border-b border-white/10 py-3' : 'bg-transparent py-5'}`} data-id="element-53">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-54">
        <Link to="/" className="flex items-center gap-2 z-50" data-id="element-55">
          <Zap className="text-lime fill-lime" size={28} data-id="element-56" />
          <span className="font-heading font-black text-3xl tracking-tighter italic -skew-x-6" data-id="element-57">
            ITS ON <span className="text-lime" data-id="element-58">FANTASY</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-59">
          {navLinks.map(link => <Link key={link.name} to={link.path} className="text-sm font-bold uppercase tracking-wider text-slate hover:text-white transition-colors" data-id="element-60">
              {link.name}
            </Link>)}
          <Link to="/pricing" className="bg-lime text-charcoal px-6 py-3 rounded-lg font-black font-heading text-xl uppercase tracking-wide hover:bg-white hover:scale-105 transition-all shadow-[0_4px_15px_rgba(200,255,0,0.3)]" data-id="element-61">
            Start Your Season
          </Link>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden z-50 text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-62">
          {isMobileMenuOpen ? <X size={28} data-id="element-63" /> : <Menu size={28} data-id="element-64" />}
        </button>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-65">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="absolute top-0 left-0 w-full h-screen bg-charcoal flex flex-col items-center justify-center gap-8 z-40" data-id="element-66">
              {navLinks.map(link => <Link key={link.name} to={link.path} onClick={() => setIsMobileMenuOpen(false)} className="text-3xl font-black font-heading uppercase tracking-wider text-white" data-id="element-67">
                  {link.name}
                </Link>)}
              <Link to="/pricing" onClick={() => setIsMobileMenuOpen(false)} className="bg-lime text-charcoal px-8 py-4 rounded-lg font-black font-heading text-2xl uppercase tracking-wide mt-4" data-id="element-68">
                Start Your Season
              </Link>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
};
export const Footer = () => {
  return <footer className="bg-dark border-t border-white/10 pt-20 pb-8" data-id="element-69">
      <div className="container mx-auto px-4 md:px-6" data-id="element-70">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-71">
          <div className="col-span-1 md:col-span-1" data-id="element-72">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-73">
              <Zap className="text-lime fill-lime" size={24} data-id="element-74" />
              <span className="font-heading font-black text-2xl tracking-tighter italic -skew-x-6" data-id="element-75">
                ITS ON <span className="text-lime" data-id="element-76">FANTASY</span>
              </span>
            </Link>
            <p className="text-slate text-lg font-medium" data-id="element-77">
              The AI that ruins your Sunday... in the best way.
            </p>
          </div>

          <div data-id="element-78">
            <h4 className="font-heading font-black text-xl uppercase tracking-wider mb-6" data-id="element-79">
              Product
            </h4>
            <ul className="space-y-3" data-id="element-80">
              <li data-id="element-81">
                <Link to="/#how-it-works" className="text-slate hover:text-lime transition-colors" data-id="element-82">
                  How It Works
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/characters" className="text-slate hover:text-lime transition-colors" data-id="element-84">
                  Characters
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/pricing" className="text-slate hover:text-lime transition-colors" data-id="element-86">
                  Pricing
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/pricing" className="text-slate hover:text-lime transition-colors" data-id="element-88">
                  Draft Day Rental
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-89">
            <h4 className="font-heading font-black text-xl uppercase tracking-wider mb-6" data-id="element-90">
              For Leagues
            </h4>
            <ul className="space-y-3" data-id="element-91">
              <li data-id="element-92">
                <Link to="/pricing" className="text-slate hover:text-lime transition-colors" data-id="element-93">
                  Commissioner Pack
                </Link>
              </li>
              <li data-id="element-94">
                <Link to="/#school-spirit" className="text-slate hover:text-lime transition-colors" data-id="element-95">
                  School Spirit Mode
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/pricing" className="text-slate hover:text-lime transition-colors" data-id="element-97">
                  Affiliate Program
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-98">
            <h4 className="font-heading font-black text-xl uppercase tracking-wider mb-6" data-id="element-99">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-100">
              <li data-id="element-101">
                <a href="#" className="text-slate hover:text-lime transition-colors" data-id="element-102">
                  About
                </a>
              </li>
              <li data-id="element-103">
                <a href="#" className="text-slate hover:text-lime transition-colors" data-id="element-104">
                  Contact
                </a>
              </li>
              <li data-id="element-105">
                <a href="#" className="text-slate hover:text-lime transition-colors" data-id="element-106">
                  Terms
                </a>
              </li>
              <li data-id="element-107">
                <a href="#" className="text-slate hover:text-lime transition-colors" data-id="element-108">
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-109">
          <p className="text-slate text-sm" data-id="element-110">© 2026 ITSONfantasy.com</p>
          <p className="text-slate text-sm text-center md:text-right" data-id="element-111">
            Not affiliated with Sleeper, ESPN, or your real feelings about your
            fantasy team.
          </p>
        </div>
      </div>
    </footer>;
};